<script>
  import { page } from '$app/stores';
  import { store, getCity } from '$client';
  const { cities, city } = store;
  export let data;
  const defaultCity = getCity($page.url.origin);
  $: ({ pages } = data);
  $: allCities = [{ attributes: $city }, ...$cities];
  let separated = { Услуги: [], Новости: [], 'Другие страницы': [], Проекты: [], FAQ: [], Категории: [] };
  $: Object.entries(pages).forEach(([url, page]) => {
    if (url.endsWith('poisk') || url.endsWith('undefined')) return;
    let key = 'Другие страницы';
    if (url.startsWith('/usluga-')) key = 'Услуги';
    if (url.startsWith('/kategoriya-')) key = 'Категории';
    if (url.startsWith('/partnery/')) key = 'Проекты';
    if (url.startsWith('/faq')) key = 'FAQ';
    if (url.startsWith('/media-center/')) key = 'Новости';
    separated[key].push(page);
  });
</script>

<section id="main" class="container margin-block">
  <h1 class="margin-bottom h1">Карта сайта</h1>
  {#each allCities as { attributes: city }}
    <article>
      <h2 class="h2">Карта для г. {city.header}</h2>
      <nav>
        <ul>
          {#each Object.entries(separated) as [header, list]}
            <li>
              <h3>{header}</h3>
              <ul data-type={list.length > 20 ? 'grid-3' : list.length > 10 ? 'grid-2' : 'flex'}>
                {#each list as page}
                  <li>
                    <a class="color-button" href={city.url === defaultCity ? page.url : '/gorod-' + city.url + page.url}
                      >{page.header}</a>
                  </li>
                {/each}
              </ul>
            </li>
          {/each}
        </ul>
      </nav>
    </article>
  {/each}
</section>

<style lang="scss">
  h1 {
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
    font-style: normal;
  }

  h2 {
    margin-bottom: 20px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;
    font-style: normal;
  }

  h3 {
    overflow: hidden;
    color: #2c333c;
    font-weight: 600;
    font-size: 18px;
    font-family: Roboto;
    font-style: normal;
    line-height: 140%; /* 25.2px */
    text-overflow: ellipsis;
  }

  article {
    margin-block: 25px;
  }

  nav > ul {
    display: inline-flex;
    flex-shrink: 1;
    flex-wrap: wrap;
    gap: 25px;

    > li {
      display: flex;
      flex-direction: column;

      ul {
        grid-gap: 8px 20px;
        margin-block: 20px;

        &[data-type='grid-3'] {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          width: 100%;

          @media only screen and (max-width: 991.98px) {
            grid-template-columns: 1fr 1fr;
          }

          @media only screen and (max-width: 575.98px) {
            grid-template-columns: 1fr;
          }
        }

        &[data-type='grid-2'] {
          display: grid;
          grid-template-columns: 1fr 1fr;

          @media only screen and (max-width: 575.98px) {
            grid-template-columns: 1fr;
          }
        }

        &[data-type='flex'] {
          display: flex;
          flex-direction: column;
        }

        a {
          display: -webkit-box;
          align-self: stretch;
          overflow: hidden;
          color: rgb(44 51 60 / 85%);
          font-weight: normal;
          font-size: 16px;
          font-family: Roboto;
          font-style: normal;
          line-height: 140%; /* 22.4px */
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }
    }
  }
</style>
